export const IncidentRoutes = {
    SaveIncident: "Incident/SaveIncident",
    GetIncident: "Incident/GetIncident",
    GetIncidentClientModel: "Incident/GetIncidentClientModel",
    ChangeStatus: "Incident/ChangeStatus",
    RemoveInc: "Incident/RemoveInc",
    ComputeIncidentGracePeriod: "Incident/ComputeIncidentGracePeriod",
    OverrideDetails: "Incident/OverrideDetails"
}